import { Component, OnInit, ViewEncapsulation, ViewChild, ElementRef, Input, Output } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal/modal.component';
import { HorizonCalc } from '../horizoncalc/horizoncalc';
import {Observable} from 'rxjs/Rx';
import { TimerComponent } from '../game/timer.component';

import { HorizonCalcComponentService } from '../horizoncalc/horizoncalcComponent.service';
import { Subscription }   from 'rxjs/Subscription';


@Component({
  selector: 'horizoncalc-header',
  templateUrl: './header-horizoncalc.component.html',
  providers: [TimerComponent, HorizonCalc],
  encapsulation: ViewEncapsulation.None
})
export class HeaderHorizonCalcComponent implements OnInit {

  constructor(public _srvc: HorizonCalcComponentService, private _horizonCalc: HorizonCalc, private elRef:ElementRef) {
    
  }

  public status:{isopen:boolean} = {isopen: false};
  public start:boolean = false;
  
  @ViewChild('startSwitch') startSwitch;
  public toggleDropdown($event:MouseEvent):void {
    $event.preventDefault();
    $event.stopPropagation();
    this.status.isopen = !this.status.isopen;
    console.log('status: ' + this.status.isopen);
  }

  public toggleStart(){
    this.start = !this.start;
    console.log('toggle start', this.start);
    this.startSwitch.nativeElement.checked = this.start;
    this._srvc.SwitchView(this.start);      
  }
  ngOnInit() {
    
  }

  ngOnDestroy() {
    
  }
}



// WEBPACK FOOTER //
// ./src/app/layouts/header-horizoncalc.component.ts